import { render, staticRenderFns } from "./commands-list.vue?vue&type=template&id=b93db5ba&scoped=true&"
import script from "./commands-list.vue?vue&type=script&lang=js&"
export * from "./commands-list.vue?vue&type=script&lang=js&"
import style0 from "./commands-list.vue?vue&type=style&index=0&id=b93db5ba&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b93db5ba",
  null
  
)

export default component.exports